import { render, staticRenderFns } from "./ProductVariantNew.vue?vue&type=template&id=ed132ebc"
import script from "./ProductVariantNew.vue?vue&type=script&lang=js"
export * from "./ProductVariantNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports